<template>
  <div id="app">
    <Loading />
    <router-view :key="$route.fullPath" />
    <Menu :key="$route.name" />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
